"use client"

import { Heading, Text } from "@chakra-ui/react"
import { type ComponentProps, type ReactNode } from "react"

type HeadingProps = ComponentProps<typeof Heading>

export interface ContentBlockTitleNumberProps {
  titleNumber?: number
}

interface ContentBlockTitleProps
  extends
    ContentBlockTitleNumberProps,
    Omit<HeadingProps, "children" | "title"> {
  title?: ReactNode
}

export const formatContentBlockTitleNumber = (titleNumber?: number) =>
  titleNumber === undefined
    ? undefined
    : `${String(titleNumber).padStart(2, "0")}.`

const ContentBlockTitle = ({
  title,
  titleNumber,
  ...headingProps
}: ContentBlockTitleProps) => {
  const trimmedTitle = typeof title === "string" ? title.trim() : title
  const hasTitle =
    trimmedTitle !== undefined && trimmedTitle !== "" && trimmedTitle !== null
  const formattedTitleNumber = formatContentBlockTitleNumber(titleNumber)

  if (!hasTitle) {
    return null
  }

  return (
    <>
      {formattedTitleNumber && (
        <Text
          as="span"
          color={{ base: "primary.500", _dark: "primary.200" }}
          fontFamily="mono"
          fontSize="0.8rem"
          fontWeight="medium"
          lineHeight="inherit"
        >
          {formattedTitleNumber}
        </Text>
      )}
      <Heading
        alignItems="baseline"
        as="h2"
        display="flex"
        flexWrap="wrap"
        gap={{ base: 2, md: 3 }}
        size="2xl"
        {...headingProps}
      >
        {trimmedTitle}
      </Heading>
    </>
  )
}

export default ContentBlockTitle
